import { FOOTER } from "@/constants/testIds";

export const Footer = () => (
  <footer data-testid={FOOTER.root} className="bg-bone border-t hairline">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
      <div className="md:col-span-6">
        <p className="font-serif text-3xl">
          Justis <span className="italic text-clay">Tan</span>
        </p>
        <p className="eyebrow mt-2">Finishing Carpenter — Calgary, AB</p>
      </div>
      <div className="md:col-span-3 text-sm text-ink/60 space-y-1">
        <p>Lei.jtab@gmail.com</p>
        <p>587-839-6507</p>
      </div>
      <div className="md:col-span-3 md:text-right text-xs uppercase tracking-[0.22em] text-ink/50">
        © {new Date().getFullYear()} — All rights reserved
      </div>
    </div>
  </footer>
);
